module.exports = __webpack_public_path__ + "static/media/sokol.14405d87.svg";